export interface PowerOptionLabel {
  readonly power: string
  readonly stockStatusText: string | null
}

export interface PowerOptionSource {
  readonly power: string
  readonly stockStatusText: string
  readonly isSoldOut: boolean
  readonly cartInfo: { readonly newitem: boolean }
}

export function toPowerOptionLabel(sku: PowerOptionSource): PowerOptionLabel {
  /**
   * 新作リクエスト商品については、度数プルダウンのテキストに売り切れ表記をつけない
   * @see https://my-color.esa.io/posts/588
   */
  if (sku.cartInfo.newitem && sku.isSoldOut) {
    return { power: sku.power, stockStatusText: null }
  }

  return { power: sku.power, stockStatusText: sku.stockStatusText || null }
}

/**
 * 構造化されていない文字列表現。
 * 度数と在庫状態が一続きの語に見えないよう、在庫状態は括弧で括って区切る
 */
export function formatPowerOptionText(label: PowerOptionLabel): string {
  return label.stockStatusText === null ? label.power : `${label.power} (${label.stockStatusText})`
}
